const buildIncentivesParams = _ref => {
  let {
    hasIncentivesUrl,
    activeTab,
    zip,
    ...rest
  } = _ref;
  return hasIncentivesUrl ? {
    dealType: activeTab,
    zip
  } : {
    dealType: activeTab,
    zip,
    ...rest
  };
};
export { buildIncentivesParams as default };
